export default __webpack_public_path__ + "static/media/OPC-2.ef1be62f.png";